export default defineNuxtRouteMiddleware((to, from) => {
  const { homePath } = useHome();
  const localePath = useLocalePath();
  const userStore = useUserStore();

  if (!userStore.isAuthenticated) {
    return navigateTo(homePath.value as string);
  }

  if (userStore.isInactiveUser && !from.meta.allowConfirmationPage) {
     return navigateTo(localePath('/plans'));
  }
});
